import { oz } from '@weft/utils';
import { CreditLedgerEntryTypeSchema } from './credit-ledger-entry-type-schema';

export const CreditLedgerEntrySchema = oz.object({
  type: CreditLedgerEntryTypeSchema,
  amount: oz.number(),
  invoiceId: oz.string().optional(),
  balanceAfterEntry: oz.number(),
}).openapi('CreditLedgerEntry');

export type CreditLedgerEntry = oz.infer<typeof CreditLedgerEntrySchema>;
